/**
 * @fileoverview added by tsickle
 * Generated from: util/object-transforms.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { isObject } from 'lodash-es';
import { camelCase, underscoreDelimit } from './string-utils';
/**
 * Traverse through an object, applying the given function to all items.
 * The function will receive a key and value, and must return an object
 * with a "key" and a "value".
 * @param {?} obj Object - The object to transform
 * @param {?} filterFn Function - The function to filter object keys
 * @param {?} transformFn Function - The function to apply to all keys
 * @return {?} Object The transformed object
 */
export function transformObj(obj, filterFn, transformFn) {
    /** @type {?} */
    var output = obj.constructor === Array ? [] : {};
    Object.keys(obj).forEach((/**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var transformed = transformFn(key, obj[key]);
        /** @type {?} */
        var val = transformed.val;
        if (filterFn && filterFn(val)) {
            return;
        }
        // Traverse object and array literals. Ignore any already parsed models.
        if (isObject(val) && !val.isModel) {
            /** @type {?} */
            var constructor = val.constructor;
            if (constructor === Object || constructor === Array) {
                output[transformed.key] = transformObj(transformed.val, filterFn, transformFn);
                return;
            }
        }
        output[transformed.key] = transformed.val;
    }));
    return output;
}
/**
 * Convert all object keys from underscore delimited to camel-case.
 * @param {?} objIn Object - The object with underscore delimited keys
 * @param {?=} filterFn Function - The function to filter object keys
 * @return {?} Object A copy of the object with the keys as camel-case.
 */
export function underToCamel(objIn, filterFn) {
    return transformObj(objIn, filterFn, (/**
     * @param {?} key
     * @param {?} val
     * @return {?}
     */
    function (key, val) {
        return {
            key: camelCase(key, { delimiter: '_' }),
            val: val
        };
    }));
}
/**
 * Convert all object keys from camel-case to underscore delimited.
 * Applies an additional check to split numbers from alphas at the end of
 * strings.
 * \@example
 * camelToUnder({fooBar: {zulu22: true}})
 * >>> {foo_bar: {zulu_22: true}}
 * @param {?} objIn Object - The object with camel-case keys
 * @param {?=} filterFn Function - The function to filter object keys
 * @return {?} Object A copy with the keys as underscore delimited.
 *
 */
export function camelToUnder(objIn, filterFn) {
    return transformObj(objIn, filterFn, (/**
     * @param {?} key
     * @param {?} val
     * @return {?}
     */
    function (key, val) {
        return {
            key: underscoreDelimit(key),
            val: val
        };
    }));
}
